import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ChatFilter from './filter/ChatFilter.js'
import {browserCheck} from './util/compatibility-check.js'
import sync from './network/sync.js'


if(browserCheck()){
	Vue.config.productionTip = false
	
	// 数据同步
	sync.start(()=>{
		new Vue({
		  router,
		  store,
		  render: h => h(App)
		}).$mount('#app')
	});	
}else{
	let html = `<div style="width: 800px;text-align: left;line-height: 30px;margin: 0 auto;margin-top: 50px;background-color: #EEEEEE;padding: 20px;box-shadow: 1px 1px 10px 1px #aeaeae;">
			<p>提示：您的浏览器不支持此软件，建议更换Chrome、Opera、Edge浏览器</p>
			<p>Chrome浏览器下载:<a href="https://www.google.cn/chrome/" style="color: #0e78b9;display: inline-block;margin-left: 5px;">点击下载</a></p>
			<p>Opera浏览器下载:<a href="https://www.opera.com/zh-cn" style="color: #0e78b9;display: inline-block;margin-left: 5px;">点击下载</a></p>
			<p>Edge浏览器下载:<a href="https://www.microsoft.com/zh-cn/edge" style="color: #0e78b9;display: inline-block;margin-left: 5px;">点击下载</a></p>
		</div>`;
	document.getElementById('app').innerHTML = html
}

